{
  "serie": {
    "display": "Visualizza il diagramma",
    "hide": "Nascondi il diagramma",
    "remove": "Rimuovi il diagramma",
    "displaySettings": "Visualizza le parametrizzazioni del diagramma",
    "selectColor": "Fai clic per selezionare un colore",
    "color": "Colore",
    "type": "Tipo",
    "types": {
      "line": "Linea",
      "bar": "Barra"
    }
  }
}
